import type { InferOutput } from "valibot";
import { boolean, object } from "valibot";
import { BOOLEAN_CONDITION_KEYS } from "../../constants";
import type { VariableDefinition } from "../Variable";
import { initVariable, VariableBaseSchema } from "../Variable";
import { require } from "../../utils/validation/base";
import { keyFromSelector } from "i18next";

const Schema = object({
  ...VariableBaseSchema.entries,
  defaultValue: require(boolean()),
});

export type BooleanVariableType = InferOutput<typeof Schema>;

const BooleanVariable: VariableDefinition<BooleanVariableType> = {
  type: "boolean",
  icon: "checkbox",
  schema: Schema,
  ruleConditionBehaviour: {
    variant: "boolean",
    keys: BOOLEAN_CONDITION_KEYS,
  },
  titleKey: keyFromSelector(($) => $.BOOLEAN_VARIABLE_LABEL),
};

export default initVariable(BooleanVariable);
